export default {
    //基础数据
    linkList: [],
    bestNews: [],
    systemInfo: {},
    // 首页数据
    home: {
        banner: [],
        about: [],
        bestProduct: [],
        bestNews: []
    },
    //关于我们
    columns: [],
    // 产品部分
    productColumns: [],
    productList: [],
    productTotal:1,
    // 新闻中心
    newsColumns: [],
    newsList: [],
    newsTotal:1,
    columnClass: {
        type: '',
        active: 0
    }
}



// WEBPACK FOOTER //
// ./src/store/state.js